const TaylorComponent = () => (
  <div id="vincent-hey" className="noHover">
    &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472; &#9472;&#9472; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9472;&#9472; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472;
    &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619;
    &#9608;&#9608; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617;
    &#9608;&#9608; <br></br>
    &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9608;&#9608;
    &#9619;&#9619; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619;
    &#9619;&#9619; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617;
    &#9608;&#9608; <br />
    &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9608;&#9608; &#9619;&#9619;
    &#9619;&#9619; &#9619;&#9619; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617;
    &#9608;&#9608; <br />
    &#9472;&#9472; &#9472;&#9472; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619;
    &#9619;&#9619; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9617;&#9617;
    &#9608;&#9608; <br />
    &#9472;&#9472; &#9472;&#9472; &#9608;&#9608; &#9619;&#9619; &#9608;&#9608;
    &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9617;&#9617;
    &#9608;&#9608; &#9617;&#9617; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619;
    &#9608;&#9608; <br />
    &#9472;&#9472; &#9608;&#9608; &#9617;&#9617; &#9608;&#9608; &#9608;&#9608;
    &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9617;&#9617;
    &#9608;&#9608; &#9617;&#9617; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619;
    &#9608;&#9608; <br />
    &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9619;&#9619;
    &#9608;&#9608; <br />
    &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9608;&#9608;
    &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9619;&#9619;
    &#9608;&#9608; <br />
    &#9472;&#9472; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9472;&#9472; &#9608;&#9608; &#9608;&#9608; &#9617;&#9617;
    &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9608;&#9608;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9608;&#9608;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9617;&#9617; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9608;&#9608; &#9472;&#9472;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619;
    &#9619;&#9619; &#9608;&#9608; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9608;&#9608; &#9608;&#9608; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472; <br />
    &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619;
    &#9619;&#9619; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472; <br />
    &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619;
    &#9619;&#9619; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9617;&#9617; &#9608;&#9608; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472; <br />
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619;
    &#9619;&#9619; &#9619;&#9619; &#9608;&#9608; &#9617;&#9617; &#9617;&#9617;
    &#9617;&#9617; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9619;&#9619;
    &#9619;&#9619; &#9619;&#9619; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9472;&#9472; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619;
    &#9608;&#9608; <br />
    &#9472;&#9472; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619;
    &#9608;&#9608; <br />
    &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619;
    &#9608;&#9608; <br />
    &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9619;&#9619;
    &#9608;&#9608; <br />
    &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9608;&#9608; &#9608;&#9608;
    &#9608;&#9608; &#9608;&#9608; &#9608;&#9608; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472; &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9608;&#9608;
    &#9608;&#9608; <br />
    &#9608;&#9608; &#9619;&#9619; &#9619;&#9619; &#9608;&#9608; &#9608;&#9608;
    &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472; &#9472;&#9472; &#9608;&#9608; &#9608;&#9608; &#9608;&#9608;
    &#9472;&#9472; <br />
    &#9472;&#9472; &#9608;&#9608; &#9608;&#9608; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472; &#9472;&#9472;
    &#9472;&#9472;
  </div>
);
export default TaylorComponent;
